// extracted by mini-css-extract-plugin
export default {"card":"DocumentPage_card__vNlXB","page":"DocumentPage_page__IL7d0","pageWrapper":"DocumentPage_pageWrapper__ek7a9","pageWrapperActive":"DocumentPage_pageWrapperActive__GK0Zk"};